module.exports = __webpack_public_path__ + "img/logo_dark.80d37909.png";